/*
 * Module for the GL Transaction Export job parameter page
 */
rs.module("content/jobs/criteria/hibexport",

    [
        "common/select-helper",
        "common/visibility"
    ],

    function (selectHelper, visibility) {

        function initialize(jsSelectors) {

            var parameters = $.js(jsSelectors.parameters);

            var reExtractCheckbox = parameters.js(jsSelectors.reExtract);

            var newDescriptionSection = parameters.js(jsSelectors.newDescriptionSection);
            var descriptionText = newDescriptionSection.js(jsSelectors.descriptionText);

            var existingDescriptionSection = parameters.js(jsSelectors.existingDescriptionSection);
            var descriptionSelectHelper = selectHelper.getHelper(existingDescriptionSection.js(jsSelectors.descriptionSelect));

            reExtractCheckbox.change(reExtractChanged);

            // On Re-Extract check changed, switch between Export Description textbox and dropdown,
            // disabling and clearing the control that is not being used.
            function reExtractChanged() {
                var checked = reExtractCheckbox.is(':checked');

                visibility.setVisible(newDescriptionSection, !checked);
                descriptionText.prop('disabled', checked);

                visibility.setVisible(existingDescriptionSection, checked);
                descriptionSelectHelper.setDisabled(!checked);

                if (checked) {
                    descriptionText.val('');
                } else {
                    descriptionSelectHelper.selectIndex(0);
                }
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);